import { colors } from '../../shared/const';

window.AudioContext = (window.AudioContext || 
    window.webkitAudioContext || 
    window.mozAudioContext || 
    window.oAudioContext || 
    window.msAudioContext);
var audioContext = new AudioContext();

const createSoundWave = (url, context, { color , barLines }) => {  // sound url, canvas contex :- document.getElementsByTagName("canvas")[0].getContext('2d')
    let WaveColor = color || colors.indigo;
    let req = new XMLHttpRequest();
    req.open( "GET", url, true );
    req.responseType = "arraybuffer";    
    req.onreadystatechange = (e) => {
            if (req.readyState == 4) {
                if(req.status == 200)
                    audioContext.decodeAudioData(req.response, 
                    (buffer) => {
                        let canvasHeight = 40, canvasWidth = 400, drawLines = barLines || 100;
                        let leftChannel = buffer.getChannelData(0);
                        context.save();
                        context.fillStyle = 'transparent'; 
                        context.fillRect(0,0,canvasWidth,canvasHeight );
                        context.strokeStyle = WaveColor;
                        context.globalCompositeOperation = 'lighter';
                        context.translate(0,canvasHeight / 2);
                        context.lineWidth = 3;
                        let totallength = leftChannel.length;
                        let eachBlock = Math.floor(totallength / drawLines);
                        let lineGap = (canvasWidth / drawLines);
                        context.beginPath();
                        for(var i=0;i<=drawLines;i++){
                            var audioBuffKey = Math.floor(eachBlock * i);
                            var x = i*lineGap;
                            var y = leftChannel[audioBuffKey] * canvasHeight + 1 ;
                            context.moveTo( x, y );
                            context.lineTo( x, (y*-1) );
                        }
                        context.stroke();
                        context.restore();
                    });
                else
                    console.log('error during the load.Wrong url or cross origin issue')
            }
    } ;
    req.send();
}

export default createSoundWave;